/* eslint-disable no-param-reassign */
/**
 * Created by zad on 17/10/25.
 */
import Immutable from 'immutable';
import { User } from '../../constants/actionTypes';

const initialState = {
  user: {
    md_auto_scroll: 0,
  },
  status: User.USER_INIT,
  otpChannel: {
    data: undefined,
    status: User.USER_OTP_CHANNEL_INIT,
  },
};

export default function (state = Immutable.fromJS(initialState), action) {
  switch (action.type) {
    // get文章
    case User.GET_USER:
      state = state.setIn(['status'], User.GET_USER);
      return state;
    case User.GET_USER_SUCCESS: {
      const { data } = action;
      state = state.setIn(['user'], Immutable.fromJS(data));
      state = state.setIn(['status'], User.GET_USER_SUCCESS);
      // try to set sentry user's context
      try {
        if (window.Raven) {
          window.Raven.setUserContext(data);
        } else {
          window.pageData = { user: data };
        }
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
      return state;
    }
    case User.GET_USER_FAIL:
      state = state.setIn(['status'], User.GET_USER_FAIL);
      return state;
    case User.SET_USER: {
      const { data } = action;
      const user = state.get('user');
      state = state.setIn(['user'], user.mergeDeep(Immutable.fromJS(data)));
      return state;
    }
    case User.CHANGE_EDITOR_TYPE_SUCCESS: {
      const { editorType } = action;
      state = state.setIn(['user', 'preferred_note_type'], editorType);
      return state;
    }
    // 获取用户的验证方式
    case User.GET_USER_OTP_CHANNEL:
      state = state.setIn(['otpChannel', 'status'], User.GET_USER_OTP_CHANNEL);
      return state;
    case User.GET_USER_OTP_CHANNEL_SUCCESS: {
      const { data } = action;
      state = state.setIn(['otpChannel', 'data'], Immutable.fromJS(data));
      state = state.setIn(['otpChannel', 'status'], User.GET_USER_OTP_CHANNEL_SUCCESS);
      return state;
    }
    case User.GET_USER_OTP_CHANNEL_FAIL:
      state = state.setIn(['otpChannel', 'status'], User.GET_USER_OTP_CHANNEL_FAIL);
      return state;
    case User.SWITCH_SYNC_SCROLL: {
      const { on } = action;
      state = state.setIn(['user', 'md_auto_scroll'], on);
      return state;
    }
    case User.SWITCH_SYNC_SCROLL_FAIL: {
      // 失败之后设置为之前的状态
      const { on } = action;
      state = state.setIn(['user', 'md_auto_scroll'], !on);
      return state;
    }
    default:
      return state;
  }
}

export const getState = state => state.User;
export const getUserOtpChannelState = state => state.User.getIn(['otpChannel']);



// WEBPACK FOOTER //
// ./src/reducers/User/UserReducer.js